import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';

@Directive({
  selector: '[roles]',
})
export class RolesDirective {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              public authenticationService: AuthenticationService) {
    this.authenticationService.authenticationEvents$.subscribe(
      () => {
        this.setRoles(this.settedRoles);
      }
    );
  }

  @Input()
  public rolesInverted = false;

  @Input()
  set roles(allowedRoles: Array<string>) {
    this.settedRoles = allowedRoles;
    this.setRoles(allowedRoles);
  }

  private settedRoles = [];

  private setRoles(allowedRoles: Array<string>) {
    const hasRole = this.authenticationService.userHasOneOfThoseRoles(allowedRoles);
    this.viewContainer.clear();
    if (this.rolesInverted !== hasRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
    }
  }
}
